export default "__VITE_ASSET__W50MJoMl__"